import { CreateDisplayGroup, CreateDisplayGroupVariables } from './__generated__/CreateDisplayGroup'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const MUTATION = gql`
  mutation CreateDisplayGroup($input: CreateDisplayGroupInputV2!) {
    createDisplayGroupV2(input: $input) {
      ... on DisplayGroupErrorV2 {
        type
        error
      }
      ... on DisplayGroupV2 {
        id
        createdAt
        ownerId
        title
        boards {
          id
        }
      }
    }
  }
`

export const useCreateDisplayGroup = () => {
  return useMutation<CreateDisplayGroup, CreateDisplayGroupVariables>(MUTATION)
}
